import { Template } from '../../domain/entities/Template'
import { TemplateRule } from '../../domain/entities/TemplateRule'

export interface PayloadRuleDTO {
  group_id: number
  chutes: number[]
  priority: number
  max_capacity?: number | null
  provider?: { name: string; code: string } | null
  provider_service?: { name: string; code: string } | null
}

export interface OutboundTemplateDto {
  name: string
  classification_type_id?: number
  groups: PayloadRuleDTO[]
}

export function toPayloadRuleDTO(rule: TemplateRule, priority: number): PayloadRuleDTO {
  return {
    group_id: rule.groupId,
    chutes: rule.chutes,
    priority,
    max_capacity: rule.maxCapacity && rule.maxCapacity > 0 ? rule.maxCapacity : null,
    provider: rule.provider ? { name: rule.provider.name, code: String(rule.provider.code) } : null,
    provider_service: rule.providerService ? { name: rule.providerService.name, code: String(rule.providerService.code) } : null,
  }
}

export function toPayloadTemplateDTO(template: Template): OutboundTemplateDto {
  return {
    name: template.name,
    classification_type_id: template.operationMode?.id,
    groups: template.rules.map((rule, index) => toPayloadRuleDTO(rule, index + 1)),
  }
}

export interface ApiGroupDTO {
  id: number
  name: string
  chutes: number[]
  priority?: number | null
  max_capacity?: number | null
  providerService?: {
    name: string
    code: string
    provider?: { name: string; code: string }
  }
}

export interface ApiTemplateDetailDTO {
  id: number
  classification_type_id?: number
  classificationType?: { key: string; description: string }
  created_at: string
  groups: ApiGroupDTO[]
  name?: string
}

export function fromApiTemplateDetail(apiData: ApiTemplateDetailDTO): Template {
  return {
    id: apiData.id,
    name: apiData.name || '',
    operationMode: apiData.classificationType
      ? {
          id: apiData.classification_type_id ?? 0,
          code: apiData.classificationType.key,
          name: apiData.classificationType.description,
        }
      : undefined,
    rules: apiData.groups
      .slice()
      .sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0))
      .map(group => ({
        groupId: group.id,
        name: group.name,
        chutes: group.chutes,
        priority: group.priority ?? null,
        maxCapacity: group.max_capacity ?? null,
        provider: group.providerService?.provider
          ? { name: group.providerService.provider.name, code: group.providerService.provider.code }
          : null,
        providerService: group.providerService
          ? { name: group.providerService.name, code: group.providerService.code }
          : null,
      })),
  }
}
